import { render, staticRenderFns } from "./FileHeaderCustomer.vue?vue&type=template&id=18e0d153"
import script from "./FileHeaderCustomer.vue?vue&type=script&lang=js"
export * from "./FileHeaderCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports